<div class="kt-form">
	<h6 class="mb-4">Send SMS to: {{data.fullName}} ({{data.phoneNumber}})</h6>
	<div class="form-group">
		<label >Sender <span class="text-danger">*</span></label>
		<input type="text" class="form-control" [(ngModel)]="smsOriginator"/>
		<span class="form-text text-muted">Max length is 11 characters!</span>
	</div>
	<div class="form-group mb-3">
		<label>Message<span class="text-danger">*</span></label>
		<textarea class="form-control" rows="4" [(ngModel)]="smsBody"></textarea>
	</div>
</div>
<div class="row mb-2 no-gutters mt-3">
  <div class="col-12">
    <button mat-button class="float-left ml-2" (click)="onNoClick()">Cancel</button>&nbsp;
    <button mat-button class="float-right mr-2" (click)="onYesClick()" [disabled]="smsBody.length === 0" color="primary">OK</button>
  </div>
</div>
